import { render, staticRenderFns } from "./socialMedia.vue?vue&type=template&id=de521404&scoped=true&"
import script from "./socialMedia.vue?vue&type=script&lang=js&"
export * from "./socialMedia.vue?vue&type=script&lang=js&"
import style0 from "./socialMedia.vue?vue&type=style&index=0&id=de521404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de521404",
  null
  
)

export default component.exports